(() => {
  const firstKey = "lehuo_attribution_first_v3";
  const currentKey = "lehuo_attribution_current_v3";
  const legacyFirstKey = "lehuo_attribution_first_v2";
  const legacyCurrentKey = "lehuo_attribution_current_v2";
  const temporaryFirstKey = "lehuo_attribution_temporary_first_v3";
  const sourcePageKey = "lehuo_attribution_source_page_v3";
  const geoTouchKey = "lehuo_geo_touch_v1";
  const firstMaxAge = 90 * 24 * 60 * 60 * 1000;
  const currentMaxAge = 30 * 60 * 1000;
  const geoTouchLimit = 20;
  const geoEventStringLimit = 300;
  const campaignKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "oppref"];
  const formKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "oppref",
    "first_landing_page",
    "current_landing_page",
    "first_referrer",
    "current_referrer",
    "first_referrer_domain",
    "current_referrer_domain",
    "traffic_classification",
    "paid_signal",
    "source_page",
    "page_handle",
    "form_location",
    "product_code",
    "product_name",
    "product_handle",
    "product_category",
    "collection_handle",
    "collection_title",
    "geo_page",
    "guide_handle",
    "first_geo_page",
    "last_geo_page",
    "geo_pages_touched",
    "geo_page_count",
    "button_location",
  ];
  const internalHosts = new Set([
    "dongfongstudio.com",
    "www.dongfongstudio.com",
    "xghz1i-n9.myshopify.com",
  ]);
  const paidMedia = new Set(["cpc", "ppc", "paid", "paid_social", "paid_ai"]);
  const geoPageInventory = new Map([
    ["/pages/fitness-accessories-manufacturer-for-startups", { handle: "fitness-accessories-manufacturer-for-startups", type: "geo_page" }],
    ["/pages/custom-lifting-grips-manufacturer", { handle: "custom-lifting-grips-manufacturer", type: "geo_page" }],
    ["/pages/low-moq-private-label-fitness-accessories", { handle: "low-moq-private-label-fitness-accessories", type: "geo_page" }],
    ["/pages/ddp-shipping-for-fitness-brands", { handle: "ddp-shipping-for-fitness-brands", type: "geo_page" }],
    ["/pages/private-label-lifting-straps-manufacturer", { handle: "private-label-lifting-straps-manufacturer", type: "buyer_guide" }],
    ["/pages/how-to-choose-lifting-grip-materials", { handle: "how-to-choose-lifting-grip-materials", type: "buyer_guide" }],
    ["/pages/private-label-fitness-accessories-packaging", { handle: "private-label-fitness-accessories-packaging", type: "buyer_guide" }],
  ]);
  const whatsappCodes = {
    straps_manufacturer_a: "GPTADS-STRAPS-A",
    straps_range_b: "GPTADS-STRAPS-B",
    straps_brand_c: "GPTADS-STRAPS-C",
    grips_manufacturer_a: "GPTADS-GRIPS-A",
    grips_materials_b: "GPTADS-GRIPS-MATERIALS",
    grips_brand_c: "GPTADS-GRIPS-C",
  };
  const whatsappMessages = {
    "GPTADS-STRAPS-A": "Hello, I am interested in private-label lifting straps.",
    "GPTADS-STRAPS-B": "Hello, I would like to explore lifting strap styles for my brand.",
    "GPTADS-STRAPS-C": "Hello, I am interested in custom lifting straps and packaging.",
    "GPTADS-GRIPS-A": "Hello, I am interested in custom lifting grips.",
    "GPTADS-GRIPS-MATERIALS": "Hello, I would like to compare lifting grip materials.",
    "GPTADS-GRIPS-C": "Hello, I am developing a lifting grip range for my brand.",
  };

  const clean = (value, max = 240) => String(value || "").trim().slice(0, max);
  const normalHost = (value) => clean(value, 200).toLowerCase().replace(/\.$/, "");
  let privacyApiLoadStarted = false;
  let privacyApiReadyNotified = false;
  const analyticsAllowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch {
      return false;
    }
  };
  const loadPrivacyApi = (callback) => {
    if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === "function") {
      if (!privacyApiReadyNotified) {
        privacyApiReadyNotified = true;
        callback();
      }
      return;
    }
    if (privacyApiLoadStarted || typeof window.Shopify?.loadFeatures !== "function") return;
    privacyApiLoadStarted = true;
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
      if (!error && typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === "function" && !privacyApiReadyNotified) {
        privacyApiReadyNotified = true;
        callback();
      }
    });
  };
  const safeRead = (storage, key) => {
    try {
      const value = JSON.parse(storage.getItem(key) || "null");
      return value && typeof value === "object" && !Array.isArray(value) ? value : null;
    } catch {
      return null;
    }
  };
  const safeWrite = (storage, key, value) => {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch {
      return;
    }
  };
  const normalizedPath = (value = window.location.pathname) => {
    try {
      const path = new URL(value, window.location.origin).pathname.replace(/\/{2,}/g, "/");
      return clean(path.length > 1 ? path.replace(/\/$/, "") : path, 180) || "/";
    } catch {
      return "/";
    }
  };
  const geoPageForPath = (value = window.location.pathname) => geoPageInventory.get(normalizedPath(value)) || null;
  const geoTouchContext = () => {
    const stored = safeRead(window.sessionStorage, geoTouchKey);
    const touched = Array.isArray(stored?.geo_pages_touched)
      ? stored.geo_pages_touched
          .filter((item) => item && geoPageInventory.has(normalizedPath(item.path)))
          .slice(0, geoTouchLimit)
          .map((item) => {
            const path = normalizedPath(item.path);
            const inventory = geoPageInventory.get(path);
            return { path, handle: inventory.handle, type: inventory.type, first_seen: clean(item.first_seen, 40) };
          })
      : [];
    return {
      first_geo_page: touched[0]?.path || "",
      last_geo_page: touched.length ? normalizedPath(stored?.last_geo_page || touched[touched.length - 1].path) : "",
      geo_pages_touched: touched,
    };
  };
  const recordGeoTouch = () => {
    const path = normalizedPath();
    const inventory = geoPageForPath(path);
    const context = geoTouchContext();
    if (!inventory) return context;
    if (!context.geo_pages_touched.some((item) => item.path === path) && context.geo_pages_touched.length < geoTouchLimit) {
      context.geo_pages_touched.push({
        path,
        handle: inventory.handle,
        type: inventory.type,
        first_seen: new Date().toISOString(),
      });
    }
    context.first_geo_page = context.geo_pages_touched[0]?.path || path;
    context.last_geo_page = path;
    safeWrite(window.sessionStorage, geoTouchKey, context);
    return context;
  };
  const geoEventContext = () => {
    const context = geoTouchContext();
    const handles = [];
    context.geo_pages_touched.forEach((item) => {
      const next = [...handles, item.handle].join("|");
      if (next.length <= geoEventStringLimit) handles.push(item.handle);
    });
    return {
      first_geo_page: clean(context.first_geo_page, 180),
      last_geo_page: clean(context.last_geo_page, 180),
      geo_page_count: context.geo_pages_touched.length,
      geo_pages_touched: handles.join("|"),
    };
  };
  const geoFormContext = () => {
    const context = geoTouchContext();
    return {
      first_geo_page: clean(context.first_geo_page, 180),
      last_geo_page: clean(context.last_geo_page, 180),
      geo_pages_touched: clean(context.geo_pages_touched.map((item) => item.handle).join(" | "), 500),
      geo_page_count: context.geo_pages_touched.length,
    };
  };
  const isInternalHost = (hostname) => {
    const host = normalHost(hostname);
    const currentHost = normalHost(window.location.hostname);
    return host === currentHost || internalHosts.has(host);
  };
  const isGoogleHost = (hostname) => {
    const host = normalHost(hostname);
    return /(?:^|\.)google\.(?:com|[a-z]{2}|com\.[a-z]{2}|co\.[a-z]{2})$/.test(host);
  };
  const isChatGPTHost = (hostname) => {
    const host = normalHost(hostname);
    return host === "chatgpt.com" || host.endsWith(".chatgpt.com") || host === "chat.openai.com";
  };
  const isInstagramHost = (hostname) => {
    const host = normalHost(hostname);
    return host === "instagram.com" || host.endsWith(".instagram.com");
  };
  const isSearchHost = (hostname) => {
    const host = normalHost(hostname);
    return (
      host === "bing.com" ||
      host.endsWith(".bing.com") ||
      host === "search.yahoo.com" ||
      host === "duckduckgo.com" ||
      host.endsWith(".baidu.com") ||
      host.endsWith(".yandex.com") ||
      host.endsWith(".yandex.ru") ||
      host === "ecosia.org" ||
      host.endsWith(".ecosia.org")
    );
  };
  const referrerInfo = () => {
    if (!document.referrer) return { url: "", domain: "", external: false };
    try {
      const referrer = new URL(document.referrer);
      if (isInternalHost(referrer.hostname)) return { url: "", domain: "", external: false };
      return {
        url: `${referrer.origin}${referrer.pathname}`.slice(0, 300),
        domain: normalHost(referrer.hostname).slice(0, 120),
        external: true,
      };
    } catch {
      return { url: "", domain: "", external: false };
    }
  };
  const safeLanding = (parameters) => {
    const safe = new URL(window.location.pathname, window.location.origin);
    campaignKeys.forEach((key) => {
      const value = clean(parameters.get(key), 180);
      if (value) safe.searchParams.set(key, value);
    });
    return `${safe.pathname}${safe.search}`.slice(0, 500);
  };
  const paidSignal = (touch) => {
    const source = clean(touch.utm_source).toLowerCase();
    const medium = clean(touch.utm_medium).toLowerCase();
    const oppref = clean(touch.oppref);
    const chatgptSource = source === "chatgpt" || source === "chatgpt.com";
    const mediumSignal = chatgptSource && medium === "cpc"
      ? "utm_cpc"
      : chatgptSource && medium === "paid_ai"
        ? "utm_paid_ai"
        : "";
    if (oppref && mediumSignal) return `oppref+${mediumSignal}`;
    if (oppref) return "oppref";
    return mediumSignal;
  };
  const classify = (touch) => {
    const source = clean(touch.utm_source).toLowerCase();
    const medium = clean(touch.utm_medium).toLowerCase();
    const campaign = clean(touch.utm_campaign).toLowerCase();
    const domain = normalHost(touch.current_referrer_domain || touch.first_referrer_domain);
    const oppref = clean(touch.oppref);
    if (((source === "chatgpt" || source === "chatgpt.com") && (medium === "cpc" || medium === "paid_ai")) || oppref) {
      return "ChatGPT Ads";
    }
    if (paidMedia.has(medium)) return "Other Paid Campaign";
    if ((source === "ig" || source === "instagram" || source === "instagram.com") && (medium === "social" || medium === "organic_social")) {
      return "Instagram Organic";
    }
    if (!oppref && medium !== "cpc" && medium !== "paid_ai" && (source === "chatgpt.com" || source === "chatgpt" || isChatGPTHost(domain))) {
      return "ChatGPT Organic";
    }
    if (
      isGoogleHost(domain) &&
      ((!source && !medium && !campaign) || (source === "google" && medium === "organic" && !campaign))
    ) {
      return "Google Organic";
    }
    if (isSearchHost(domain) && !source && !medium && !campaign) return "Other Organic Search";
    if (isInstagramHost(domain) && !source && !medium && !campaign) return "Instagram Organic";
    if (source || medium || campaign) return "Other Campaign";
    if (domain) return "Referral";
    return "Direct";
  };
  const sourceAmbiguity = (touch) => {
    const source = clean(touch.utm_source).toLowerCase();
    const medium = clean(touch.utm_medium).toLowerCase();
    const domain = normalHost(touch.current_referrer_domain || touch.first_referrer_domain);
    return source === "chatgpt" && medium !== "cpc" && medium !== "paid_ai" && !clean(touch.oppref) && !isChatGPTHost(domain)
      ? "chatgpt_bare_source"
      : "";
  };
  const sourcePlatform = (touch) => {
    const classification = classify(touch);
    if (classification === "Google Organic") return "google";
    if (classification === "Instagram Organic") return "instagram";
    if (classification === "ChatGPT Organic" || classification === "ChatGPT Ads") return "chatgpt";
    return clean(touch.utm_source, 80).toLowerCase();
  };
  const sourceAccount = (touch) => {
    if (classify(touch) !== "Instagram Organic") return "";
    const campaign = clean(touch.utm_campaign).toLowerCase();
    if (campaign.includes("dongfongmoments")) return "dongfongmoments";
    if (campaign.includes("dongfongstudio")) return "dongfongstudio";
    return "instagram";
  };
  const hasExplicitSource = (touch) => {
    return campaignKeys.some((key) => clean(touch[key])) || Boolean(clean(touch.current_referrer_domain));
  };
  const buildTouch = (parameters) => {
    const now = new Date().toISOString();
    const referrer = referrerInfo();
    const touch = {
      current_landing_page: safeLanding(parameters),
      current_referrer: referrer.url,
      current_referrer_domain: referrer.domain,
      current_touch_time: now,
    };
    campaignKeys.forEach((key) => {
      const value = clean(parameters.get(key), 180);
      if (value) touch[key] = value;
    });
    touch.traffic_classification = classify(touch);
    touch.paid_signal = paidSignal(touch);
    touch.source_ambiguity = sourceAmbiguity(touch);
    if (touch.traffic_classification === "Google Organic" && !touch.utm_source && !touch.utm_medium) {
      touch.utm_source = "google";
      touch.utm_medium = "organic";
    }
    touch.source_platform = sourcePlatform(touch);
    touch.source_account = sourceAccount(touch);
    return touch;
  };
  const toFirstTouch = (touch) => {
    const first = {
      first_landing_page: clean(touch.current_landing_page, 500) || "/",
      first_referrer: clean(touch.current_referrer, 300),
      first_referrer_domain: normalHost(touch.current_referrer_domain).slice(0, 120),
      first_touch_time: clean(touch.current_touch_time, 40) || new Date().toISOString(),
      traffic_classification: classify(touch),
      paid_signal: paidSignal(touch),
      source_platform: sourcePlatform(touch),
      source_account: sourceAccount(touch),
      source_ambiguity: sourceAmbiguity(touch),
    };
    campaignKeys.forEach((key) => {
      const value = clean(touch[key], 180);
      if (value) first[key] = value;
    });
    return first;
  };
  const firstTouchValid = (touch) => {
    if (!touch || typeof touch !== "object" || Array.isArray(touch)) return false;
    if (!clean(touch.first_landing_page, 500) || !clean(touch.traffic_classification, 80)) return false;
    if (!Number.isFinite(Date.parse(clean(touch.first_touch_time, 40)))) return false;
    const external = ["Google Organic", "Other Organic Search", "Instagram Organic", "Referral", "ChatGPT Organic"].includes(touch.traffic_classification);
    const campaign = campaignKeys.some((key) => clean(touch[key]));
    if (external && !campaign && (!clean(touch.first_referrer) || !normalHost(touch.first_referrer_domain))) return false;
    return true;
  };
  const firstTouchExpired = (touch, now) => {
    const time = Date.parse(clean(touch?.first_touch_time, 40));
    return !Number.isFinite(time) || now - time > firstMaxAge;
  };
  const currentTouchValid = (touch, now) => {
    const time = Date.parse(clean(touch?.current_touch_time, 40));
    return Boolean(clean(touch?.current_landing_page, 500)) && Number.isFinite(time) && now - time <= currentMaxAge;
  };
  const activeAttribution = () => {
    const parameters = new URLSearchParams(window.location.search);
    const volatileTouch = buildTouch(parameters);
    const now = Date.now();
    let temporaryFirst = safeRead(window.sessionStorage, temporaryFirstKey);
    if (!firstTouchValid(temporaryFirst) || firstTouchExpired(temporaryFirst, now)) {
      temporaryFirst = toFirstTouch(volatileTouch);
      safeWrite(window.sessionStorage, temporaryFirstKey, temporaryFirst);
    }

    let first = temporaryFirst;
    if (analyticsAllowed()) {
      const persistedFirst = safeRead(window.localStorage, firstKey);
      if (firstTouchValid(persistedFirst) && !firstTouchExpired(persistedFirst, now)) {
        first = persistedFirst;
      } else {
        const legacyFirst = safeRead(window.localStorage, legacyFirstKey);
        first = firstTouchValid(legacyFirst) && !firstTouchExpired(legacyFirst, now) ? legacyFirst : temporaryFirst;
        safeWrite(window.localStorage, firstKey, first);
      }
    }

    let current = safeRead(window.sessionStorage, currentKey);
    if (!currentTouchValid(current, now)) current = safeRead(window.sessionStorage, legacyCurrentKey);
    if (!currentTouchValid(current, now)) current = null;
    if (hasExplicitSource(volatileTouch)) {
      current = volatileTouch;
    } else if (current) {
      current.current_landing_page = volatileTouch.current_landing_page;
      current.current_touch_time = volatileTouch.current_touch_time;
    } else {
      current = volatileTouch;
    }
    current.traffic_classification = classify(current);
    current.paid_signal = paidSignal(current);
    current.source_platform = sourcePlatform(current);
    current.source_account = sourceAccount(current);
    current.source_ambiguity = sourceAmbiguity(current);
    safeWrite(window.sessionStorage, currentKey, current);
    return { first, current };
  };
  const eventParameters = (attribution, extra = {}) => ({
    campaign: clean(attribution.current.utm_campaign, 100),
    content: clean(attribution.current.utm_content, 100),
    term: clean(attribution.current.utm_term, 100),
    source_page: clean(safeRead(window.sessionStorage, sourcePageKey)?.value || window.location.pathname, 180),
    landing_page: clean(attribution.current.current_landing_page, 300),
    traffic_classification: clean(attribution.current.traffic_classification, 80),
    paid_signal: clean(attribution.current.paid_signal, 40),
    source_platform: clean(attribution.current.source_platform, 80),
    source_account: clean(attribution.current.source_account, 80),
    source_ambiguity: clean(attribution.current.source_ambiguity, 80),
    ...geoEventContext(),
    ...extra,
  });
  const emitEvent = (name, parameters) => {
    if (!analyticsAllowed()) return false;
    if (typeof window.Shopify?.analytics?.publish === "function") {
      try {
        window.Shopify.analytics.publish(name, parameters);
        return true;
      } catch {
        return false;
      }
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", name, parameters);
      return true;
    }
    window.dataLayer = window.dataLayer || [];
    (function queueGtagEvent() {
      window.dataLayer.push(arguments);
    })("event", name, parameters);
    return true;
  };
  const pathHandle = () => clean(window.location.pathname.split("/").filter(Boolean).pop(), 120);
  const mergedFields = (attribution, parameters) => {
    const storedSource = safeRead(window.sessionStorage, sourcePageKey);
    return {
      ...attribution.current,
      ...geoFormContext(),
      utm_source: clean(parameters.get("utm_source") || attribution.current.utm_source, 180),
      utm_medium: clean(parameters.get("utm_medium") || attribution.current.utm_medium, 180),
      utm_campaign: clean(parameters.get("utm_campaign") || attribution.current.utm_campaign, 180),
      utm_term: clean(parameters.get("utm_term") || attribution.current.utm_term, 180),
      utm_content: clean(parameters.get("utm_content") || attribution.current.utm_content, 180),
      oppref: clean(parameters.get("oppref") || attribution.current.oppref, 180),
      first_landing_page: clean(parameters.get("first_landing_page") || attribution.first.first_landing_page, 500),
      first_referrer: clean(parameters.get("first_referrer") || attribution.first.first_referrer, 300),
      first_referrer_domain: normalHost(parameters.get("first_referrer_domain") || attribution.first.first_referrer_domain).slice(0, 120),
      current_landing_page: clean(parameters.get("current_landing_page") || attribution.current.current_landing_page, 500),
      current_referrer: clean(parameters.get("current_referrer") || attribution.current.current_referrer, 300),
      current_referrer_domain: normalHost(parameters.get("current_referrer_domain") || attribution.current.current_referrer_domain).slice(0, 120),
      traffic_classification: clean(attribution.current.traffic_classification, 80) || "Direct / Source Unknown",
      source_page: clean(parameters.get("source_page") || storedSource?.value || window.location.pathname, 180),
      page_handle: clean(parameters.get("page_handle") || storedSource?.page_handle || document.querySelector("[data-guide-handle]")?.dataset.guideHandle || pathHandle(), 120),
      form_location: clean(parameters.get("form_location") || "contact_form", 100),
      product_code: clean(parameters.get("product_code") || storedSource?.product_code, 100),
      product_name: clean(parameters.get("product_name") || storedSource?.product_name, 180),
      product_handle: clean(parameters.get("product_handle") || storedSource?.product_handle, 120),
      product_category: clean(parameters.get("product_category") || storedSource?.product_category, 120),
      collection_handle: clean(parameters.get("collection_handle") || storedSource?.collection_handle, 120),
      collection_title: clean(parameters.get("collection_title") || storedSource?.collection_title, 180),
      geo_page: clean(parameters.get("geo_page") || storedSource?.geo_page, 120),
      guide_handle: clean(parameters.get("guide_handle") || storedSource?.guide_handle || document.querySelector("[data-guide-handle]")?.dataset.guideHandle, 120),
      button_location: clean(parameters.get("button_location") || storedSource?.button_location || "contact_form", 100),
    };
  };
  const eligibleQuoteLinks = () => {
    const links = new Set(document.querySelectorAll("[data-lehuo-quote]"));
    if (!geoPageForPath()) return [...links];
    document.querySelectorAll("a[href]").forEach((link) => {
      try {
        const destination = new URL(link.href, window.location.origin);
        const label = clean(link.textContent || link.getAttribute("aria-label"), 120);
        if (
          destination.protocol.startsWith("http") &&
          isInternalHost(destination.hostname) &&
          normalizedPath(destination.pathname) === "/pages/contact" &&
          /(?:request|get).{0,16}quote|contact/i.test(label)
        ) {
          links.add(link);
        }
      } catch {
        return;
      }
    });
    return [...links];
  };
  const decorateQuoteLinks = (attribution) => {
    const currentGeo = geoPageForPath();
    const fields = mergedFields(attribution, new URLSearchParams(window.location.search));
    if (currentGeo) {
      fields.geo_page = currentGeo.handle;
      fields.guide_handle = currentGeo.handle;
    }
    eligibleQuoteLinks().forEach((link) => {
      if (link.dataset.lehuoQuoteBound !== "true") {
        link.dataset.lehuoQuoteBound = "true";
        link.addEventListener("click", () => {
          try {
            recordGeoTouch();
            const destination = new URL(link.href, window.location.origin);
            const actualSource = clean(window.location.pathname, 180) || "/";
            const buttonLocation = clean(link.dataset.buttonLocation || destination.searchParams.get("form_location") || "quote_link", 100);
            const sourceContext = {
              value: actualSource,
              page_handle: pathHandle(),
              product_code: clean(destination.searchParams.get("product_code"), 100),
              product_name: clean(destination.searchParams.get("product_name"), 180),
              product_handle: clean(destination.searchParams.get("product_handle"), 120),
              product_category: clean(destination.searchParams.get("product_category"), 120),
              collection_handle: clean(destination.searchParams.get("collection_handle"), 120),
              collection_title: clean(destination.searchParams.get("collection_title"), 180),
              geo_page: clean(destination.searchParams.get("geo_page") || currentGeo?.handle, 120),
              guide_handle: clean(destination.searchParams.get("guide_handle") || currentGeo?.handle || document.querySelector("[data-guide-handle]")?.dataset.guideHandle, 120),
              button_location: buttonLocation,
              time: new Date().toISOString(),
            };
            safeWrite(window.sessionStorage, sourcePageKey, sourceContext);
            destination.searchParams.set("source_page", actualSource);
            destination.searchParams.set("page_handle", sourceContext.page_handle);
            destination.searchParams.set("button_location", buttonLocation);
            link.href = destination.toString();
          } catch {
            return;
          }
        });
      }
      try {
        const destination = new URL(link.href, window.location.origin);
        const syntheticGoogle =
          attribution.current.traffic_classification === "Google Organic" &&
          !clean(attribution.current.current_landing_page).includes("utm_source=");
        if (syntheticGoogle) {
          destination.searchParams.delete("utm_source");
          destination.searchParams.delete("utm_medium");
        }
        formKeys.forEach((key) => {
          const value = clean(fields[key], 500);
          if (value && key !== "source_page" && !(syntheticGoogle && (key === "utm_source" || key === "utm_medium"))) {
            destination.searchParams.set(key, value);
          }
        });
        link.href = destination.toString();
      } catch {
        return;
      }
    });
  };
  const whatsappMessage = (attribution, link) => {
    const content = clean(attribution.current.utm_content, 100);
    const page = link.closest("[data-gpt-ads-page]")?.dataset.gptAdsPage;
    if (attribution.current.traffic_classification === "ChatGPT Ads") {
      const fallbackCodes = { straps: "GPTADS-STRAPS-A", grips: "GPTADS-GRIPS-A", materials: "GPTADS-GRIPS-MATERIALS" };
      const code = whatsappCodes[content] || fallbackCodes[page];
      if (code) return `${whatsappMessages[code]}\n\nReference: ${code}`;
    }
    if (attribution.current.traffic_classification === "ChatGPT Organic") {
      const organic = {
        straps: { message: "Hello, I am interested in private-label lifting straps.", code: "CHATGPT-ORGANIC-STRAPS" },
        grips: { message: "Hello, I am interested in custom lifting grips.", code: "CHATGPT-ORGANIC-GRIPS" },
        materials: { message: "Hello, I would like to compare lifting grip material options.", code: "CHATGPT-ORGANIC-GRIP-MATERIALS" },
      };
      if (organic[page]) return `${organic[page].message}\n\nReference: ${organic[page].code}`;
    }
    if (page === "straps") return "Hello, I am interested in private-label lifting straps.";
    if (page === "materials") return "Hello, I would like to compare lifting grip materials.";
    if (page === "grips") return "Hello, I am interested in custom lifting grips.";
    return "";
  };
  const decorateWhatsAppLink = (link, attribution) => {
    try {
      const destination = new URL(link.href);
      const message = whatsappMessage(attribution, link);
      if (message) destination.searchParams.set("text", message);
      link.href = destination.toString();
    } catch {
      return;
    }
  };
  const setupWhatsApp = (attribution) => {
    document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"]').forEach((link) => {
      decorateWhatsAppLink(link, attribution);
      if (link.dataset.lehuoWhatsappBound === "true") return;
      link.dataset.lehuoWhatsappBound = "true";
      link.addEventListener("click", () => {
        const active = activeAttribution();
        const fields = mergedFields(active, new URLSearchParams(window.location.search));
        decorateWhatsAppLink(link, active);
        const location = clean(link.dataset.buttonLocation || (link.closest("footer") ? "footer_whatsapp" : "floating_whatsapp"), 100);
        emitEvent("whatsapp_click", eventParameters(active, {
          page_type: document.querySelector("[data-gpt-ads-page]") ? "gpt_ads_landing" : "page",
          guide_handle: clean(geoPageForPath()?.handle || document.querySelector("[data-guide-handle]")?.dataset.guideHandle, 120),
          product_code: clean(fields.product_code, 100),
          product_category: clean(fields.product_category, 120),
          button_location: location,
        }));
      });
    });
  };
  const selectedCountryMetadata = (select) => {
    const option = select?.selectedOptions?.[0];
    return {
      name: clean(option?.value, 120),
      iso: clean(option?.dataset.countryIso, 2).toUpperCase(),
      callingCode: clean(option?.dataset.callingCode, 4).replace(/\D/g, ""),
      trunkPrefix: clean(option?.dataset.trunkPrefix, 2).replace(/\D/g, ""),
    };
  };
  const normalizeWhatsAppNumber = (value, country) => {
    const compact = clean(value, 80).replace(/[\s().\-]/g, "");
    if (!compact) return { value: "", valid: false, countryMatch: true };
    let international = compact;
    if (international.startsWith("00")) international = `+${international.slice(2)}`;
    if (international.startsWith("+")) {
      const digits = international.slice(1);
      const valid = /^\d{7,15}$/.test(digits);
      return {
        value: `+${digits}`,
        valid,
        countryMatch: !valid || !country.callingCode || digits.startsWith(country.callingCode),
      };
    }
    if (!/^\d+$/.test(international) || !country.callingCode) {
      return { value: international, valid: false, countryMatch: true };
    }
    let national = international;
    if (country.trunkPrefix && national.startsWith(country.trunkPrefix)) {
      national = national.slice(country.trunkPrefix.length);
    }
    const digits = `${country.callingCode}${national}`;
    return { value: `+${digits}`, valid: /^\d{7,15}$/.test(digits), countryMatch: true };
  };
  const setFieldError = (field, error, message) => {
    if (!field) return;
    field.setCustomValidity(message);
    if (message) field.setAttribute("aria-invalid", "true");
    else field.removeAttribute("aria-invalid");
    if (error) error.textContent = message;
  };
  const validateInquiryForm = (form, normalize = true) => {
    const countryField = form.querySelector("[data-lehuo-country]");
    const whatsappField = form.querySelector("[data-lehuo-whatsapp]");
    const stageField = form.querySelector("[data-lehuo-project-stage]");
    const countryError = form.querySelector('[data-lehuo-error="country"]');
    const whatsappError = form.querySelector('[data-lehuo-error="whatsapp"]');
    const stageError = form.querySelector('[data-lehuo-error="project-stage"]');
    const country = selectedCountryMetadata(countryField);
    const countryMessage = country.name && country.callingCode ? "" : "Please select your country or region.";
    setFieldError(countryField, countryError, countryMessage);
    const stageMessage = "";
    setFieldError(stageField, stageError, stageMessage);
    const normalized = normalizeWhatsAppNumber(whatsappField?.value, country);
    const whatsappMessage = !normalized.valid
      ? "Please enter a valid WhatsApp number."
      : !normalized.countryMatch
        ? "The WhatsApp number does not appear to match the selected country."
        : "";
    setFieldError(whatsappField, whatsappError, whatsappMessage);
    if (!whatsappMessage && normalize && whatsappField) whatsappField.value = normalized.value;
    return !countryMessage && !whatsappMessage && form.checkValidity();
  };

  const setupForms = (attribution) => {
    const parameters = new URLSearchParams(window.location.search);
    document.querySelectorAll("[data-lehuo-inquiry-form]").forEach((form) => {
      const fields = mergedFields(attribution, parameters);
      const countryField = form.querySelector("[data-lehuo-country]");
      const whatsappField = form.querySelector("[data-lehuo-whatsapp]");
      const stageField = form.querySelector("[data-lehuo-project-stage]");
      const callingCodeHelper = form.querySelector("[data-lehuo-calling-code]");
      const updateCallingCodeHelper = () => {
        const country = selectedCountryMetadata(countryField);
        if (callingCodeHelper) {
          callingCodeHelper.textContent = country.callingCode
            ? `Selected calling code: +${country.callingCode}`
            : "Select a country to see its calling code.";
        }
      };
      updateCallingCodeHelper();
      if (!parameters.get("source_page") && !safeRead(window.sessionStorage, sourcePageKey)?.value) {
        fields.source_page = clean(form.dataset.defaultSourcePage || fields.source_page, 180);
      }
      if (!parameters.get("form_location")) fields.form_location = clean(form.dataset.defaultFormLocation || fields.form_location, 100);
      formKeys.forEach((key) => {
        const field = form.querySelector(`[data-lehuo-param="${key}"]`);
        if (field) field.value = clean(fields[key], 500);
      });
      const firstField = form.querySelector("[data-lehuo-first-touch]");
      const currentField = form.querySelector("[data-lehuo-current-touch]");
      if (firstField) firstField.value = JSON.stringify(attribution.first);
      if (currentField) currentField.value = JSON.stringify(attribution.current);
      if (analyticsAllowed() && form.dataset.lehuoQuoteViewSent !== "true") {
        const sent = emitEvent("quote_form_view", eventParameters(attribution, { button_location: clean(fields.button_location || "contact_form", 100) }));
        if (sent) form.dataset.lehuoQuoteViewSent = "true";
      }
      if (form.dataset.lehuoFormBound !== "true") {
        form.dataset.lehuoFormBound = "true";
        countryField?.addEventListener("change", () => {
          updateCallingCodeHelper();
          setFieldError(countryField, form.querySelector('[data-lehuo-error="country"]'), "");
          if (whatsappField?.value.trim()) {
            const result = normalizeWhatsAppNumber(whatsappField.value, selectedCountryMetadata(countryField));
            setFieldError(
              whatsappField,
              form.querySelector('[data-lehuo-error="whatsapp"]'),
              result.valid && result.countryMatch ? "" : result.valid ? "The WhatsApp number does not appear to match the selected country." : "Please enter a valid WhatsApp number."
            );
          }
        });
        whatsappField?.addEventListener("input", () => {
          setFieldError(whatsappField, form.querySelector('[data-lehuo-error="whatsapp"]'), "");
        });
        whatsappField?.addEventListener("blur", () => {
          const result = normalizeWhatsAppNumber(whatsappField.value, selectedCountryMetadata(countryField));
          if (result.valid && result.countryMatch) whatsappField.value = result.value;
        });
        stageField?.addEventListener("change", () => {
          setFieldError(stageField, form.querySelector('[data-lehuo-error="project-stage"]'), "");
        });
        let started = false;
        const start = () => {
          if (started) return;
          const sent = emitEvent("quote_start", eventParameters(activeAttribution(), { button_location: clean(fields.button_location || "contact_form", 100) }));
          if (sent) started = true;
        };
        form.addEventListener("focusin", start);
        form.addEventListener("input", start);
        form.addEventListener("submit", (event) => {
          if (!validateInquiryForm(form, true)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            form.querySelector('[aria-invalid="true"], :invalid')?.focus();
            return;
          }
          const submit = form.querySelector("[data-lehuo-submit]");
          if (!submit) return;
          submit.disabled = true;
          submit.setAttribute("aria-busy", "true");
          window.setTimeout(() => {
            submit.disabled = false;
            submit.removeAttribute("aria-busy");
          }, 10000);
        });
      }
    });
  };
  const setupLandingEvent = (attribution) => {
    if (!analyticsAllowed()) return;
    const classification = attribution.current.traffic_classification;
    if (classification !== "ChatGPT Ads" && classification !== "ChatGPT Organic") return;
    const eventName = classification === "ChatGPT Organic" ? "chatgpt_organic_landing" : "chatgpt_ad_landing";
    const marker = `lehuo_${eventName}_v3`;
    try {
      if (window.sessionStorage.getItem(marker)) return;
    } catch {
      return;
    }
    const currentGeo = geoPageForPath();
    const sent = emitEvent(eventName, eventParameters(attribution, {
      page_type: classification === "ChatGPT Ads" ? "gpt_ads_landing" : currentGeo?.type || (normalizedPath() === "/" ? "homepage" : "page"),
      page_handle: clean(currentGeo?.handle || document.querySelector("[data-guide-handle]")?.dataset.guideHandle, 120),
      guide_handle: clean(currentGeo?.handle || document.querySelector("[data-guide-handle]")?.dataset.guideHandle, 120),
      product_category: clean(document.querySelector("[data-gpt-ads-page]")?.dataset.gptAdsPage, 80),
    }));
    if (sent) {
      try {
        window.sessionStorage.setItem(marker, "1");
      } catch {
        return;
      }
    }
  };
  const setupLeadSuccess = (attribution) => {
    if (!analyticsAllowed() || !document.querySelector("[data-lehuo-inquiry-success='true']")) return;
    const parameters = new URLSearchParams(window.location.search);
    const marker = `lehuo_quote_success_v3:${window.location.pathname}:${parameters.get("contact_posted") || "posted"}`;
    try {
      if (window.sessionStorage.getItem(marker)) return;
    } catch {
      return;
    }
    const payload = eventParameters(attribution, { button_location: clean(parameters.get("button_location") || "contact_form", 100) });
    const quoteSent = emitEvent("quote_submit", payload);
    const leadSent = emitEvent("generate_lead", payload);
    if (quoteSent && leadSent) {
      try {
        window.sessionStorage.setItem(marker, "1");
      } catch {
        return;
      }
    }
  };
  const setup = () => {
    recordGeoTouch();
    const attribution = activeAttribution();
    decorateQuoteLinks(attribution);
    setupWhatsApp(attribution);
    setupForms(attribution);
    setupLandingEvent(attribution);
    setupLeadSuccess(attribution);
    loadPrivacyApi(setup);
  };

  document.addEventListener("visitorConsentCollected", setup);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup, { once: true });
  } else {
    setup();
  }
})();

